'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

define(['app'], function (app) {
  var MS_IN_A_DAY = 24 * 60 * 60 * 1000;
  var DEFAULT_COUNTDOWN_HRS = 21;
  var removeCloak = function removeCloak(el) {
    return el.classList.remove('cloak');
  };

  var $interval = function $interval(fn, ms) {
    var id = setInterval(fn, ms);
    return function () {
      return clearInterval(id);
    };
  };

  var countDown = function countDown() {
    var component = {};

    var _config = {
      props: {
        countDownTo: { // this attribute should be something that `new Date()` could parse
          selector: 'data-count-down-to',
          defaultValue: function defaultValue() {
            var date = new Date();
            date.setHours(DEFAULT_COUNTDOWN_HRS);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);

            if (Date.now() > date.getTime()) date.setTime(date.getTime() + MS_IN_A_DAY);
            return date.getTime();
          },
          transform: function transform(n) {
            return new Date(parseInt(n));
          }
        }
      },
      children: {
        hrs: '.countDown_hrs',
        mins: '.countDown_mins',
        secs: '.countDown_secs'
      },
      computed: {
        get remainingHrs() {
          return component.computed.remainingMins / 60;
        },
        get remainingMins() {
          return component.computed.remainingSecs / 60;
        },
        get remainingSecs() {
          return component.computed.remainingMs / 1000;
        },
        get remainingMs() {
          return component.props.countDownTo.getTime() - Date.now();
        },
        get remainingRoundedHrs() {
          return Math.floor(component.computed.remainingHrs);
        },
        get remainingRoundedMins() {
          return Math.floor(component.computed.remainingMins % 60);
        },
        get remainingRoundedSecs() {
          return Math.floor(component.computed.remainingSecs % 60);
        },
        get isCountdownOver() {
          return component.computed.remainingMs <= 0;
        }
      }
    };

    var _init = function _init(element) {
      component.element = element;

      component.children = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(_config.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var childrenName = _ref2[0];
          var childrenSelector = _ref2[1];

          component.children[childrenName] = element.querySelector(childrenSelector);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      component.props = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.entries(_config.props)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = _slicedToArray(_ref3, 2);

          var propName = _ref4[0];
          var _ref4$ = _ref4[1];
          var selector = _ref4$.selector;
          var defaultValue = _ref4$.defaultValue;
          var _ref4$$transform = _ref4$.transform;
          var transform = _ref4$$transform === undefined ? function (x) {
            return x;
          } : _ref4$$transform;

          component.props[propName] = transform(element.getAttribute(selector) || defaultValue());
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      component.tick();

      component.stopTicking = $interval(component.tick, 1000);

      removeCloak(element);

      return component;
    };

    var _tick = function _tick() {
      if (component.computed.isCountdownOver) {
        component.element.classList.add('countDown_hide');
        component.stopTicking();
        return;
      }

      component.children.hrs.innerHTML = component.computed.remainingRoundedHrs;
      component.children.mins.innerHTML = component.computed.remainingRoundedMins;
      component.children.secs.innerHTML = component.computed.remainingRoundedSecs;
    };

    component.init = _init;
    component.tick = _tick;
    component.computed = _config.computed;

    return component;
  };

  return countDown;
});
//# sourceMappingURL=countDown.js.map
